export default function LinkedInSvg() {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_341_492)'>
        <path
          d='M0.157837 1.72487C0.157837 0.772539 0.94943 5.34058e-05 1.92596 5.34058e-05H22.3162C23.2927 5.34058e-05 24.0844 0.772539 24.0844 1.72487V22.3535C24.0844 23.3062 23.2927 24.0784 22.3162 24.0784H1.92596C0.94943 24.0784 0.157837 23.3062 0.157837 22.3535V1.72487Z'
          fill='#0A66C2'
        />
        <path
          clipRule='evenodd'
          d='M7.41077 20.156V9.2833H3.79688V20.156H7.41077ZM5.60381 7.79881C6.86405 7.79881 7.64844 6.96391 7.64844 5.92053C7.62495 4.85365 6.86405 4.04192 5.62772 4.04192C4.39152 4.04192 3.58325 4.85365 3.58325 5.92053C3.58325 6.96391 4.36748 7.79881 5.58026 7.79881H5.60381Z'
          fill='white'
          fillRule='evenodd'
        />
        <path
          clipRule='evenodd'
          d='M9.4104 20.156H13.0243V14.0842C13.0243 13.7593 13.0477 13.4346 13.1432 13.2024C13.4044 12.5531 13.999 11.8807 14.9974 11.8807C16.3051 11.8807 16.8282 12.8777 16.8282 14.3394V20.156H20.4418V13.9218C20.4418 10.5821 18.6589 9.02816 16.2812 9.02816C14.3316 9.02816 13.4757 10.1179 13.0002 10.8601H13.0244V9.2833H9.4105C9.45792 10.3035 9.4104 20.156 9.4104 20.156Z'
          fill='white'
          fillRule='evenodd'
        />
      </g>
      <defs>
        <clipPath id='clip0_341_492'>
          <rect fill='white' height='24' width='24' />
        </clipPath>
      </defs>
    </svg>
  )
}
